/* eslint-disable max-len */
import React, { useState, useCallback, useEffect } from 'react';
import FormContents from 'components/atoms/Form/FormContents';
// import { useOrgTreesOptionsManagedCustom } from 'hooks/useOrgTreesOptions';
import SelectForm from 'components/molecules/SelectForm';
import FormField from 'components/atoms/Form/FormField';
import BodyText from 'components/atoms/BodyText';
import { utilityColor, grayScale } from 'components/styles';
// import Checkbox from 'components/molecules/Checkbox';
import PrimaryButton, { SecondaryButton } from 'components/atoms/Button';
import useToastNotification from 'hooks/useToastNotification';
import ConfirmModal from 'components/organismos/ConfirmModal';
import FormPadding from 'components/atoms/Form/FormPadding';
import { Row, Col } from 'react-grid-system';
import { css } from '@emotion/core';
import { useOrgTreesOptionsAllV1 } from 'hooks/useOrgTreesOptions';
import FormHeader from 'components/templates/FormHeader';
import BlockUI from 'components/molecules/BlockUi';
import FlexBox from 'components/atoms/FlexBox';

const MasterShopSpecifyLayout = () => {
  const LOCAL_STORAGE_SHOP_INFO_KEY_NAME: string = 'win-board-localstorage-shop-info';
  const storageEncode = localStorage.getItem(LOCAL_STORAGE_SHOP_INFO_KEY_NAME);
  const storage: any = storageEncode ? JSON.parse(storageEncode) : '';
  const orgTreesOptions = useOrgTreesOptionsAllV1(undefined, undefined, undefined, false);
  const [specifyCode, setSpecifyCode] = useState(storage ? storage.specifyCode : '');
  const [stampByBelongOrg, setStampByBelongOrg] = useState(!!(Number(storage.stampByBelongOrg) === 1));
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const { successNotification, errorNotification } = useToastNotification();
  const [confirmModel, setConfirmModel] = useState(false);
  const [confirmClearModel, setConfirmClearModel] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if(orgTreesOptions && sessionStorage.getItem('loginUser.site') !== '3'){
      let objectOrg = orgTreesOptions.filter((item) => {
        return item.orgCode === sessionStorage.getItem('loginUser.orgCode')
      })[0];
      if (objectOrg){
        setSpecifyCode(objectOrg.value);
      }
    }
  }, [orgTreesOptions])

  const handleAdd = useCallback(() => {
    setConfirmModel(false);
    // if (specifyCode === '' || specifyCode === undefined) {
    //   errorNotification('組織を選択してください。');
    // } else {
    //   const registeredMap = {
    //     specifyCode,
    //     companyCode,
    //     stampByBelongOrg: stampByBelongOrg ? 1 : 0,
    //   };

    //   localStorage.setItem(LOCAL_STORAGE_SHOP_INFO_KEY_NAME, JSON.stringify(registeredMap));
    //   successNotification('組織を登録しました。');
    // }
    const registeredMap = {
      specifyCode,
      companyCode,
      stampByBelongOrg: stampByBelongOrg ? 1 : 0
    };
    localStorage.setItem(LOCAL_STORAGE_SHOP_INFO_KEY_NAME, JSON.stringify(registeredMap));
    successNotification('組織を登録しました。');
  },
  [companyCode, errorNotification, specifyCode, stampByBelongOrg, successNotification]);

  const handleClear = () => {
    if(sessionStorage.getItem('loginUser.site') === '3') {
      setSpecifyCode(undefined);
    }
    localStorage.removeItem(LOCAL_STORAGE_SHOP_INFO_KEY_NAME);
    setConfirmClearModel(false);
    setStampByBelongOrg(false);
    successNotification('組織情報をクリアしました。');
  };

  return (
      <BlockUI blocking={isLoading}>
      <FormHeader title="端末への組織登録"/>
      <FormContents customStyle={css({marginTop:'60px'})}>
        <FormPadding>
          <Row>
            <Col>
              <FormField displayBlock={true}>
                <FlexBox>
                  <SelectForm
                    label="組織"
                    placeholder="組織を選択してください"
                    name="specifyCode" 
                    value={specifyCode}
                    setValue={(v) => {
                      setSpecifyCode(v);
                    }}
                    options={
                      sessionStorage.getItem('loginUser.site') === '3' ? orgTreesOptions : orgTreesOptions.filter((org) => org.value !== '')
                    }
                    description=""
                    ghost={(['3', '2'].indexOf(sessionStorage.getItem('loginUser.site') || "") === -1 && orgTreesOptions.length === 1)}
                    width='583px'
                  />
                </FlexBox>
                
              </FormField>
            </Col>
          </Row>
          <div style={{ marginLeft: '100px' }}>
            <div>
              <BodyText size="sm" color={utilityColor.error}>端末に組織情報を登録します。</BodyText>
            </div>
            <div>
              <BodyText size="sm" color={utilityColor.error}>組織情報を登録することで、組織サイトへの自動ログイン、タイムレコーダーが使用できるようになります。</BodyText>
            </div>
            {/* <div>
              <FormField>
                <Checkbox
                  id="stampByBelongOrg"
                  name="stampByBelongOrg"
                  value={stampByBelongOrg ? 'checked' : 'unchecked'}
                  label="所属組織で打刻する"
                  checked={stampByBelongOrg}
                  onChange={(e) => {
                    setStampByBelongOrg(!stampByBelongOrg);
                  }}
                />
              </FormField>
              <div>
                <BodyText color={utilityColor.error}>チェックをすると、打刻時の出勤組織はスタッフの所属組織になります。</BodyText>
              </div>
              <div>
                <BodyText color={utilityColor.error}>チェックを外すと、打刻時の出勤組織はこの画面の「組織名」で指定した組織になります。</BodyText>
              </div>
            </div> */}
          </div>
          <div style={{ textAlign: 'center', margin: '16px 0' }}>
            <div>
              <PrimaryButton 
                minWidth="160px" 
                text="登録する" 
                onClick={() => setConfirmModel(true)}
                disabled={!storageEncode ? false : true}
              />
            </div>
            <div>
              <SecondaryButton
                minWidth="160px" 
                onClick={() => setConfirmClearModel(true)}
                text="クリア"
                disabled={storageEncode ? false : true}
                customStyle={css`
                  margin-top: 16px;
                  :disabled{
                    background-color: ${grayScale.gray20};
                    opacity: 0.8;
                    cursor: not-allowed
                  }
                `}
              />
            </div>
          </div>
        </FormPadding>
        <ConfirmModal
          title="端末設定"
          content="端末に組織を登録します。よろしいですか？"
          submitText="登録する"
          open={confirmModel}
          closeHandler={() => setConfirmModel(false)}
          onSubmit={handleAdd}
        />
        <ConfirmModal
          title="確認メッセージ"
          content="端末に登録されている組織情報をクリアします。</br>
          タイムレコーダーが使用できなくなりますが、よろしいですか？"
          submitText="クリアする"
          open={confirmClearModel}
          closeHandler={() => setConfirmClearModel(false)}
          onSubmit={handleClear}
          typeSubmit="reject"
        />
      </FormContents>
      </BlockUI>
  );
};

export default MasterShopSpecifyLayout;
